import React, { FC, useEffect, useState } from 'react';
import filtersStyles from '../../Filters.module.scss';
import { Action } from 'esa-ui-library';
import { PropertyType, useStore } from '../../../../../common';
import { FilterDropdown } from '../FilterDropdown/FilterDropdown';
import { getActiveLabels, selectPreselectedOptions } from '../../Filters.helper';
import { cloneDeep, find, startCase } from 'lodash';
import useFilters from '../../../../../common/hooks/useFilters';
import styles from './RealMoneyFilter.module.scss';

interface RealMoneyFilterProps {
	filterName: string;
}

const RealMoneyFilter: FC<RealMoneyFilterProps> = ({ filterName }): JSX.Element => {
	const [state] = useStore();
	const { filters } = state;
	const [filterOptions, setFiltersOptions] = useState<PropertyType[]>([]);
	const [opened, setOpened] = useState(false);
	const { onFilter } = useFilters();

	const onFilterChange = (option: PropertyType) => {
		setOpened(false);
		onFilter([{ name: filterName, value: option.value }]);
	};

	const getLabelContent = () => {
		const activeLabels = getActiveLabels(filterOptions);
		if (!activeLabels.length) return 'All';

		return (
			<>
				{activeLabels[0]}
				{activeLabels.length > 1 ? `+${activeLabels.length - 1}` : ''}
			</>
		);
	};

	useEffect(() => {
		if (state[filterName]) {
			setFiltersOptions(cloneDeep(state[filterName]));
		}
	}, [state[filterName]]);

	useEffect(() => {
		const filter = find(filters, ['name', filterName])?.value || '';
		setFiltersOptions(selectPreselectedOptions(state[filterName], filter));
	}, [filters]);

	return (
		<Action
			label={startCase(filterName)}
			labelContent={getLabelContent()}
			controlled
			onDropdownChange={setOpened}
			opened={opened}
			className={`${filtersStyles.Filter} 
			${styles.Filter} 
			${getActiveLabels(filterOptions).length ? filtersStyles.Active : ''} `}
			dataId='general-filter'
		>
			<FilterDropdown data={filterOptions} onChange={onFilterChange} isSearchable />
		</Action>
	);
};

export { RealMoneyFilter };
